import type { DateRange, DateRangePreset } from '@/components/shared/date-range-filter';

import type { CombinedReportRef } from './download-combined-report-csv';
import {
  activeReportFilterQuery,
  type ReportFilterDefinition,
} from './report-filters-bar';

export type ReportPickerValue = string;

export interface SeededReportDefinition {
  key: string;
  nameKey: string;
  supportsDateRange: boolean;
  filters?: ReportFilterDefinition[];
}

export const buildCombinedReportsPayload = (
  selectedRefs: CombinedReportRef[],
  reportFilters: Record<string, Record<string, string>>,
  seededByKey: Map<string, SeededReportDefinition>,
): CombinedReportRef[] =>
  selectedRefs.map((ref) => {
    if (ref.kind !== 'seeded') return ref;
    const identity = `seeded:${ref.key}`;
    const definition = seededByKey.get(ref.key);
    const active = activeReportFilterQuery(
      definition?.filters ?? [],
      reportFilters[identity] ?? {},
    );
    return Object.keys(active).length > 0 ? { ...ref, filters: active } : ref;
  });

export const serializeDateRange = (dateRange: DateRange) => ({
  preset: dateRange.preset,
  from: dateRange.from ?? null,
  to: dateRange.to ?? null,
});

export const deserializeDateRange = (
  saved: { preset: string; from: string | null; to: string | null },
  timezone: string,
  resolvePreset: (preset: DateRangePreset, timezone: string) => { from: string | null; to: string | null },
): DateRange => {
  if (saved.preset === 'custom') {
    return { preset: 'custom', from: saved.from, to: saved.to };
  }
  return {
    preset: saved.preset as DateRange['preset'],
    ...resolvePreset(saved.preset as DateRangePreset, timezone),
  };
};
